import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '../server/layout/Box/index';
import { Stack } from '../server/layout/Stack/index';
import styles from './Screen.module.css';
export function Screen({ children, maxWidth, padX = 'xl', padTop = 'xl', padBottom = '2xl', bg, bleed = false, }) {
    const useLegacyWell = maxWidth != null && !bleed;
    // No `height: 100%, overflow: auto` — the AppShell's `<main>` is the
    // page's sole scroll container. Adding a second scroll viewport here
    // caused tall forms (e.g. /circles/new) to overflow past Screen's
    // internal scroll boundary, leaving the bottom Publish row unreachable
    // unless the user happened to scroll-wheel over the inner div. Screen
    // is now a styling wrapper only (background + optional max-width well).
    return (_jsx(Box, { style: { background: bg ?? 'inherit' }, children: useLegacyWell ? (_jsx(Box, { px: padX, pt: padTop, pb: padBottom, style: { maxWidth, margin: '0 auto' }, children: children })) : children }));
}
const SCREEN_BODY_WIDTHS = { prose: 720 };
export function ScreenBody({ maxWidth, padX = 'xl', padTop = 'xl', padBottom = '2xl', gap = 'xl', responsivePadX = true, children, style, }) {
    const w = typeof maxWidth === 'string' ? SCREEN_BODY_WIDTHS[maxWidth] : maxWidth;
    return (_jsx(Stack, { gap: gap, px: padX, pt: padTop, pb: padBottom, className: responsivePadX ? styles.mobilePad : undefined, style: {
            maxWidth: w,
            margin: w != null ? '0 auto' : undefined,
            width: '100%',
            background: 'inherit',
            ...style,
        }, children: children }));
}
//# sourceMappingURL=Screen.js.map